import React from "react";
import useUserInfo from "../Hooks/useUserInfo";
import gameleader from "../Pages/Task/leaderboard/gameleader";
import WhackAMole from "../Pages/Task/whack-a-mole/whackamole";

function Tvborder() {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();

  // Check if current page is a game page
  const isGamePage = [
    "flappy",
    "puzzle",
    "gameleader",
    "snake",
    "Connectfour",
    "WhackAMole",
    "2048F",
    "Snake",
    "twenty",
    "SnakeGame",
    "Dark2048",
    "CricketTask",
    "Flappy",
    "rockpaperscissors",
    "quento",
    "DinoGame",
    "MemeCandy",
    "Hangman",
    "RainbowConnect",
    "Simonsays",
    "Minesweeper",
    "spaceinvader",
    "tetris",
    "jumpingorbits",
    "stacker",
    "FruitSlice",
    "CarRace",
    "Racing",
    "BeachyBall",
    "ChessWeb",
    "chess",
    "chessWeb",
    "Chess",
    "TicTacToeWeb",
    "ConnectFourWeb",
    "connectfour",
    "SnakeLadder",
    "UnoGame",
  ].includes(userDetails?.currentComponentText);


  // If it's a game page, don't render the border
  if (isGamePage) {
    return null;
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        zIndex: 10,
        pointerEvents: "none",
      }}
    >
      {/* <div
        style={{
          position: "absolute",
          height: "90px",
          width: "100%",
        }}
      >
      </div> */}

      {!isGamePage && (
        <img
          src={
            watchScreen.booster
              ? "https://d1ccopf5cw1hft.cloudfront.net/s3data/doNothingimg.png"
              : "https://d1ccopf5cw1hft.cloudfront.net/s3data/Frame+21.png"
          }
          alt="border"
          style={{ height: "100%", width: "100%" }}
        />
      )}
    </div>
  );
}

export default Tvborder;
